<template>
  <section class="pdp-gallery" :class="{ 'pdp-gallery--zooming': zoomState }">
    <div class="pdp-gallery__wrapper">

      <div class="pdp-gallery__main-container">
        <div class="pdp-gallery__main">


          <!-- <div class="pdp-gallery__product-icon" v-if="customFields.gallery_icon">
            <img :src="customFields.gallery_icon" alt="">
          </div> -->
          <div class="pdp-gallery__badge-container" v-if="variant">
            <div class="badge button-text" v-for="badge in badges" :key="badge"
              :style="`color: ${$store.state.badgeColorMap[badge][0]}; background-color: ${$store.state.badgeColorMap[badge][1]};`">
              {{ badge }}</div>
          </div>
          <button class="pdp-gallery__button pdp-gallery__button--next button--arrow-primary u-hidden-mobile-only"
            @click="slideNextMain" aria-label="Next Featured Image" v-if="productMedia.length > 1">
            <icon name="chevron-right" size="14px"></icon>
          </button>
          <button class="pdp-gallery__button pdp-gallery__button--prev button--arrow-primary u-hidden-mobile-only"
            @click="slidePrevMain" aria-label="Previous Featured Image" v-if="productMedia.length > 1">
            <icon name="chevron-left" size="14px"></icon>
          </button>
          <span class="pdp-gallery__zoom-icon" @click="() => zoomState = false" v-if="zoomState && $mq !== 'mobile'">
            <icon name="zoom_out"></icon>
          </span>
          <span class="pdp-gallery__zoom-icon" v-else-if="$mq !== 'mobile'" @click="zoomCenter">
            <icon name="zoom_in"></icon>
          </span>
          <swiper :options="swiperOptionsMain" :key="mainSwiperKey" ref="swiperMain"
            @slideChangeTransitionStart='slideChange'>
            <swiper-slide v-for="(media, index) in productMedia" :key="media.id">
              <div @click="setZoom($event, !zoomState)" @mouseleave="() => zoomState = false">
                <media :media="media" v-if="media.media_type !== 'external_video'">
                  <zoom ref="zoom" slot="image" :in-view="activeSlide === index"
                    :img-normal-attrs="{ src: media.src, alt: getProductImageAlt(media) }"
                    :img-zoom-attrs="{ src: media.src, alt: getProductImageAlt(media) }" :zooming="zoomState"
                    :disabled="!zoomState" :scale="4" />
                </media>

                <iframe v-cloak v-else-if="media.media_type === 'external_video' && media.host === 'youtube'"
                  class="yt_player_iframe" type="text/html" :width="playerWidth" :height="playerHeight" :src="mediaUrl(media)"
                  frameborder="0" allowfullscreen v-clock />
                <iframe v-cloak v-else-if="media.media_type === 'external_video' && media.host === 'vimeo'"
                  class="yt_player_iframe" type="text/html" :width="playerWidth" :height="playerHeight" :src="mediaUrl(media)"
                  frameborder="0" allowfullscreen allow="autoplay; fullscreen; picture-in-picture" />
                  <div class="video_overlay" v-if="$mq=='mobile' && media.media_type === 'external_video' && (media.host === 'vimeo' || media.host === 'youtube')" @click="playYoutube"></div>
              </div>
            </swiper-slide>
          </swiper>
          
          <div class="pdp-gallery__play-video-btn" @click="thumbSlideTo(slideVideoIndex)" v-if="$mq === 'mobile' && slideVideoIndex >= 0">
          <svg width="17" height="20" class="video-cta-icon-svg" xmlns="http://www.w3.org/2000/svg">
  <path d="M1.26953 1.25L1.25 18.71094l14.375-8.73047L1.26953 1.25zm0-1.25c.10417 0 .21484.01628.33203.04883.1172.03255.22136.08138.3125.14648l14.375 8.73047c.1823.10417.32552.25065.42969.43945.10417.1888.15625.39388.15625.61524 0 .22135-.05208.42643-.15625.61523-.10417.1888-.2474.33529-.42969.43946L1.89453 19.76563c-.09115.0651-.19531.11393-.3125.14648-.11719.03255-.22786.04883-.33203.04883-.10417 0-.20833-.01302-.3125-.03907-.10417-.02604-.20182-.0651-.29297-.11718-.20833-.1172-.36784-.27344-.47851-.46875C.05534 19.14062 0 18.93229 0 18.71094L.01953 1.25c0-.22136.05534-.42969.16602-.625C.29622.42969.45573.27344.66406.15625.75521.10417.85286.0651.95703.03906 1.0612.01302 1.16536 0 1.26953 0z" fill="#000" fill-rule="evenodd"></path>
</svg>
          </div>
          <product-featured-badges v-if="product.featuredBadges" :badges="product.featuredBadges" context="gallery" />
          <div class="product-form__detail-icons-container" v-if="$mq !== 'mobile'">
            <div class="product-form__detail-icons">
              <div class="product-form__detail-icon" v-for="(valueProp, i) in badgesWithTitle" :key="i">
                <img class="product-form__detail-icon-icon" :src="valueProp.icon">
                <span class="product-form__detail-icon-title"> {{ valueProp.title }}</span>
              </div>
            </div>
          </div>

        </div>
        <div class="text-center pdp-gallery__pagination" slot="pagination" v-if="productMedia.length > 1"></div>
        <button class="pdp-gallery__button-thumb pdp-gallery__button-thumb--next u-hidden-mobile-only"
          @click="slideNextThumb" v-show="thumbsShouldSlide" aria-label="Next Thumbnail" v-if="productMedia.length > 1">
          <icon name="chevron-down"></icon>
        </button>
        <button class="pdp-gallery__button-thumb pdp-gallery__button-thumb--prev u-hidden-mobile-only"
          @click="slidePrevThumb" v-show="thumbsShouldSlide" aria-label="Previous Thumbnail"
          v-if="productMedia.length > 1">
          <icon name="chevron-up"></icon>
        </button>
        <div class="pdp-gallery__thumbs">
          <swiper class="pdp-gallery__thumbs-slider" :options="swiperOptionThumbs" ref="thumbSwiper"
            :key="thumbSwiperKey">
            <swiper-slide v-for="(media, index) in productMedia" :key="media.src"
              :class="{ 'pdp-gallery__thumbs-slide--active': slideIndexMain() === index }">
              <button @click="thumbSlideTo(index)" :aria-label="`Go to Thumbnail ${index}`">
                <media-preview :media="media" size="162x182"></media-preview>
              </button>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import '@/scripts/typedefs'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { imageSize, fileUrl, noImageMedia, swiperLoopInit, swiperLoopSlideChange, is3rdPartyProduct, badgeList, getProductImageAlt, badge, getVariantImages } from '@/scripts/helpers/util'
import Icon from '@/scripts/components/basic/Icon.vue'
import Zoom from '@/scripts/components/basic/Zoom.vue'
import Media from '@/scripts/components/basic/Media.vue'
import MediaPreview from '@/scripts/components/basic/MediaPreview.vue'
import ProductFeaturedBadges from './ProductFeaturedBadges.vue'
import ProductThreeColumnInfo from './ProductThreeColumnInfo.vue';

export default {
  components: {
    swiper,
    swiperSlide,
    Zoom,
    Icon,
    Media,
    MediaPreview,
    ProductFeaturedBadges,
    ProductThreeColumnInfo
  },
  model: {
    prop: 'variant'
  },
  props: {
    collection: Object,
    product: Object,
    customFields: Object,
    settings: Object,
    variant: Object
  },
  data() {
    return {
      zoomState: false,
      initialSlide: 0,
      activeSlide: 0,
      mainSwiperKey: 0,
      thumbSwiperKey: 0,
      thumbsShouldSlide: false,
      isPlaying: true
    }
  },
  computed: {
    slideVideoIndex() {
        return this.productMedia.findIndex(media => media.media_type === 'external_video')
      },
    playerWidth() {
      return this.$mq === 'mobile' ? '560' : '480'
    },
    playerHeight() {
      return this.$mq === 'mobile' ? '315' : '270'
    },
    /**
     * @desc
     *  - look for images with alt tags that are either women or men and display the appropriate images, or show all images if not unisex
     */
    productMedia() {
      const images = this.product.media;
      const query = window.location.search;
      const params = new URLSearchParams(query);
      const womens = params.get('womens');
      const mens = params.get('mens');

      if (womens)
        return images.filter(image => !image.alt || !image.alt.split(' ').includes('mens'));
      else if (mens)
        return images.filter(image => !image.alt || !image.alt.split(' ').includes('womens'));
      else
        return images;
    },
    onSale() {
      return this.variant && this.variant.price < this.variant.compare_at_price
    },
    badges() {
      console.log("products",this.product)
      return badgeList(this.product, this.onSale)
    },
    badgesWithTitle() {
      let detailIconTitles = this.customFields.title ? this.customFields.title.split('|###|') : [];
      let detailIconIcons = this.customFields.icon ? this.customFields.icon.split('|###|') : [];
      return detailIconIcons.map((icon, i) => ({
        title: (detailIconTitles[i]) ? detailIconTitles[i] : '',
        icon: detailIconIcons[i]
      }));
    }
    ,
    swiperOptionsMain() {
      const vue = this;
      return {
        initialSlide: 0,
        centeredSlides: true,
        pagination: {
          el: '.pdp-gallery__pagination',
          clickable: true
        },
        threshold: 50,
        iOSEdgeSwipeDetection: true,
        iOSEdgeSwipeThreshold: 100,
        slidesPerView: 1,
        loop: true,
        on: {
          slideChange: function () {
            swiperLoopSlideChange(this, this.params.slidesPerView, vue.thumbSlideTo(vue.slideRealIndexMain()))
          }
        },
        thumbs: {
          swiper: vue.$refs.swiperMain
        },
        breakpoints: {
          768: {
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: false
          }
        }
      }
    },
    swiperOptionThumbs() {
      return {
        initialSlide: 0,
        spaceBetween: 8,
        threshold: 15,
        direction: 'vertical',
        height: 80,
        loop: false
      }
    }
  },
  methods: {
    mediaUrl(media) {
      return media.host=="youtube"?"https://www.youtube.com/embed/" + media.external_id + "?autoplay=0&controls=1&enablejsapi=1&modestbranding=1&rel=0&showinfo=0&wmode=transparent":"https://player.vimeo.com/video/"+ media.external_id;
    },
    getProductImageAlt,
    zoomCenter(event) {
      this.zoomState = true
      this.$nextTick(() => {
        const zoomContainer = this.$refs.zoom[this.slideIndexMain()]
        if (zoomContainer) { zoomContainer.zoomCenter() }
      })
    },
    setZoom(event, state) {
      this.zoomState = this.$mq === 'mobile' ? false : state
      this.$nextTick(() => {
        const zoomContainer = this.$refs.zoom[this.slideIndexMain()]
        if (zoomContainer) { zoomContainer.move(event) }
      })
    },
    slideChange() {
      this.activeSlide = this.$refs.swiperMain.swiper.activeIndex - 1;
    },
    slideNextMain() {
      this.$refs.swiperMain.swiper.slideNext()
      this.thumbSlideTo(this.slideIndexMain())
    },
    slidePrevMain() {
      this.$refs.swiperMain.swiper.slidePrev()
      this.thumbSlideTo(this.slideIndexMain())
    },
    slideNextThumb() {
      this.$refs.thumbSwiper.swiper.slideNext()
    },
    slidePrevThumb() {
      this.$refs.thumbSwiper.swiper.slidePrev()
    },
    /** @returns {Number} */
    slideIndexMain() {
      if (!this.$refs.swiperMain) return 0
      return this.$refs.swiperMain.swiper.activeIndex - 1
    },
    /** @returns {Number} */
    slideRealIndexMain() {
      if (!this.$refs.swiperMain) return 0
      return this.$refs.swiperMain.swiper.realIndex
    },
    /** @returns {Number} */
    slideIndexThumb() {
      if (!this.$refs.thumbSwiper) return 0
      return this.$refs.thumbSwiper.swiper.activeIndex - 1
    },
    playYoutube (){
      let isMoviePlaying = this.isPlaying;
      $('.yt_player_iframe').each(function () {
        if (isMoviePlaying==false){
          this.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
          this.contentWindow.postMessage('{"method":"play"}', '*');
        }else{
          this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
          this.contentWindow.postMessage('{"method":"pause"}', '*');
        }
      });
      this.isPlaying=!this.isPlaying
      
    },
    thumbSlideTo(index) {
      this.isPlaying=false;
      $('.yt_player_iframe').each(function () {
        this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
        this.contentWindow.postMessage('{"method":"pause"}', '*');
      });

      // Get array of non duplicate slides
      const nonDupSlides = Array.from(this.$refs.thumbSwiper.swiper.slides).filter((el) => !el.matches('.swiper-slide-duplicate'))
      const thumbSlides = Array.from(this.$refs.thumbSwiper.swiper.slides)

      // Slide main swiper to index
      this.$refs.swiperMain.swiper.slideToLoop(index)

      thumbSlides.forEach((thumb, index) => {
        thumb.classList.remove('pdp-gallery__thumbs-slide--active');
        thumb.classList.remove('swiper-slide-active');
      });

      this.$refs.thumbSwiper.swiper.slides[index].classList.add('pdp-gallery__thumbs-slide--active');
      this.$refs.thumbSwiper.swiper.slides[index].classList.add('swiper-slide-active');

      if (this.thumbsShouldSlide) {
        // Get slides per view based on gallery height and slide height
        const $galleryContainer = document.querySelector('.pdp-gallery__main-container')
        if (!$galleryContainer) {
          return
        }
        const slidesPerView = Math.floor($galleryContainer.getBoundingClientRect().height / (this.$refs.thumbSwiper.swiper.params.height + this.$refs.thumbSwiper.swiper.params.spaceBetween))

        // if new index + slidesPerView is greather then the number of slides and (stops duplicates from showing)
        // if the new index is less than the number of slides (not a duplicate)
        /// / slide to last set of slides
        if (index - 1 > nonDupSlides.length - slidesPerView && index - 1 < nonDupSlides.length) {
          this.$refs.thumbSwiper.swiper.slideToLoop(nonDupSlides.length - slidesPerView)
        } else {
          // otherwise slide to index
          this.$refs.thumbSwiper.swiper.slideToLoop(index > 0 ? index - 1 : index)
        }
      }
    },
    updateThumbsShouldSlide() {
      // Get slides per view based on gallery height and slide height
      const $galleryContainer = document.querySelector('.pdp-gallery__main-container')
      if (!$galleryContainer) {
        this.thumbsShouldSlide = false
        return
      }

      const slidesPerView = Math.floor($galleryContainer.getBoundingClientRect().height / (this.$refs.thumbSwiper.swiper.params.height + this.$refs.thumbSwiper.swiper.params.spaceBetween))
      this.thumbsShouldSlide = this.productMedia.length > slidesPerView
    }
  },
  mounted() {
    this.updateThumbsShouldSlide()
    window.addEventListener('resize', this.updateThumbsShouldSlide)
  }
}
</script>

<style lang="scss" scoped>
.video_overlay {
    top:0px;
    display: block;
    position: absolute;
    width: 100%;
    height: 75%;
    background: transparent;
    opacity: 0.1;
  }
.yt_player_iframe
{
  @include mobile-only {
   width: 100%!important;
    height: 58vw!important;
    padding: 20px;
  }
}
/deep/ .swiper-wrapper {
  display: flex;
  align-items: center;
}

/deep/ .swiper-pagination-bullet {
  width: 5px;
  height: 5px;
  border: 1px solid $color-black-300;
  opacity: 1;
  background: $color-black-300;
  margin: 0 2px;

  &:first-child {
    margin-left: 0;
  }
}

/deep/ .swiper-pagination-bullet-active {
  background: $color-black-900;
  border-color: $color-black-900;
}

/deep/ .swiper-slide {
  height: auto !important;

  img {
    display: block;
  }
}

.pdp-gallery {
  margin: 0;
  width: 100%;

  @include mobile-only {
    width: 100%;
    margin: 0 auto;
  }
  &__play-video-btn {
    display: flex;
    cursor: pointer;
    height: 36px;
    width: 100%;
    background: rgba(255, 255, 255, 0.7);
    align-items: center;
    justify-content: center;
    text-align: center;
    position: absolute;
    bottom: 26px;
    left: 0;
    z-index: 2;
    
    svg{
      width: 24px;
    }
    
    &:after{
      content: "VIDEO";
      font-size: 12px;
      font-weight: 500;
      letter-spacing: .8px;
      color: #000;
      margin-left: 5px;
    }
  }

  .zoom-on-hover {
    text-align: center;
  }

  &__wrapper {
    position: relative;
  }

  &__badge-container {
    position: absolute;
    top: 0;
    left: 0;
    min-height: 25px;
  }

  &__product-icon {
    position: absolute;
    bottom: 0;
    transform: translateY(50%);
    max-width: 40px;
    left: 50%;
    z-index: 10;
    display: none;

    @include tablet-up {
      display: block;
      left: auto;
      right: 185px;
      max-width: 56px;
    }
  }

  &__logo-badge {
    z-index: 4;
    height: 40px;
    margin-right: 16px;
    margin-left: 5%;

    img {
      height: 40px;
      width: auto;
    }

    @include mobile-only {
      height: 35px;

      img {
        height: 35px;
      }
    }
  }

  .badge {
    position: relative;
    top: 0;
    left: 0;
    pointer-events: none;
    padding: 0 32px;
    line-height: 26px;
    height: 25px;
    font-size: rem(16);

    &.has-logo-badge {
      @include mobile-only {
        margin-left: auto;
        margin-right: 5%;
      }
    }
  }

  &__button {
    display: none;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 5;
    font-size: 0;
    cursor: pointer;
  }

  &__pagination {
    margin-top: 10px;
    position: absolute;
    bottom: 12px;
    left: 16px;
    font-size: 0;
    z-index: 11;
  }

  &__button--next {
    right: 8px;
  }

  &__button--prev {
    left: 8px;
  }

  &__button--next svg {
    margin-right: -2px;
  }

  &__button--prev svg {
    margin-left: -2px;
    transform: rotate(180deg);
  }

  &__zoom-icon {
    position: absolute;
    top: 37px;
    right: 32px;
    display: inline-block;
    width: 38px;
    height: 38px;
    background: $color-zoom-background;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 31;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);

    @include mobile-only {
      bottom: 12px;
      top: auto;
      width: 35px;
      right: 12px;
      height: 35px;
    }
  }

  &__zoom-icon * {
    pointer-events: none;
  }

  &__thumbs-slider {
    display: none;
  }

  &__wrapper {
    max-width: 100%;
    background-color: $color-black-100;
    padding: 54px 24px 0;
  }

  @include tablet-only {
    .swiper-container {
      margin-left: 123px;
    }
  }


  @include tablet-up {
    display: inline-block;
    min-width: 50%;
    flex-basis: 50%;
    width: 50%;

    .swiper-container {
      max-width: 482px;
    }

    &__badge-container {
      display: flex;
    }

    &__wrapper {
      display: flex;
      flex-direction: row-reverse;
      justify-content: end;
      padding: 0;
    }

    &__main-container {
      display: inline-flex;
      justify-content: flex-end;
      max-width: 935px;
      width: 100%;
      position: relative;
      padding-top: 80px;
      padding-bottom: 80px;
    }

    &__main {
      width: 100%;
      order: 1;
    }

    &__badge-container {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }

    &__main &__button {
      opacity: 0;
      transition: opacity .2s linear;
    }

    &:hover &__main &__button {
      opacity: 1;
    }

    &__pagination {
      display: none;
    }

    &__thumbs-slider {
      display: block;
      // max-height: 560px;
      max-height: 100%;
    }

    &__thumbs-slider .swiper-slide {
      border: 0;
      display: flex;
      border: 1px solid $color-black-300;
      transition: all $default-animation-duration $default-animation-timing;
    }

    &__thumbs-slider .swiper-slide.pdp-gallery__thumbs-slide--active,
    &__thumbs-slider .swiper-slide:hover {
      position: relative;
      border-color: $color-black-900;
    }

    &__thumbs-slider .swiper-slide-duplicate {
      opacity: 0;
      visibility: hidden;
    }

    &__thumbs-slider button {
      height: 100%;
      width: 100%;
      overflow: hidden;
    }

    &__thumbs-slider img {
      // width: 153px;
      max-width: 100%;
    }

    .zoom-on-hover {
      cursor: zoom-in;
    }

    .zoom-on-hover .zoom {
      cursor: zoom-out;
    }

    &__zoom-icon svg {
      width: 28px !important;
      height: 28px !important;
    }

    &__button {
      width: 40px;
      height: 40px;
    }

    &__thumbs {
      position: absolute;
      left: 41px;
      top: 80px;
      display: flex;
      align-items: center;
      overflow: hidden;
      display: inline-block;
      max-width: 82px;

      .swiper-container {
        margin-left: 0 !important;
      }
    }

    &__button-thumb {
      display: none;
      position: absolute;
      left: 0;
      width: 80px;
      height: 32px;
      background: $color-black;
      opacity: .3;
      align-items: center;
      justify-content: center;
      z-index: 5;
      transition: right .2s .2s ease, left .2s .2s ease;
    }

    &__button-thumb svg {
      fill: $color-white;
    }

    &__button-thumb--next {
      bottom: 0;
    }

    &__button-thumb--prev {
      top: 0;
    }

    &__button-thumb--next:disabled {
      bottom: -33px;
    }

    &__button-thumb--prev:disabled {
      top: -33px;
    }
  }
  @include desktop-up {
    width: 64%;
  }

}

.pdp-gallery.pdp-gallery--zooming {
  .pdp-gallery__main .pdp-gallery__button {
    pointer-events: none;
    opacity: 0;
  }
}

.product-form__detail-icons-container {
  display: flex;
  align-items: center;
  margin-top: 10px;
  justify-content: center;
}
.video-cta-icon-svg{
  margin:8px;
}
</style>
